export class LegalCatalog {

  constructor() {
  }

  static getTermsAndConditionsURL() {
    return __LEGAL_URL__;
  }

  static getPrivacyNoticeURL() {
    return __PRIVACY_NOTICE_URL__;
  }
}
